/// <amd-module name="Build/Common/Commands/savedefinition/Command.types" />
import { DefinitionReference, Folder } from "Build/Client/Contracts/Build";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentProperties } from "VSS/Platform/Layout";

export interface ISaveDefinitionState {
    name: string;
    definitionPath: string;
    description: string;
    nameErrorMessage: string;
    pathErrorMessage: string;
    showFolderDialog: boolean;
}

export interface IFolderIdentifier {
    path: string;
}

export interface ISaveDefinitionProps extends IVssComponentProperties {
    pageContext: IVssPageContext;
    projectId: string;
    saveAsTemplate: boolean;
    onClose: () => any;
    definition?: DefinitionReference;
    onDefinitionSaved?: (definition: DefinitionReference) => any;
    folder?: IFolderIdentifier;
    onFolderSaved?: (folder: Folder, previousPath: string) => any;
}
